export const applyLogementFilters = (annonce, filters) => {
  const {
    transaction = [],
    type = [],
    exterieur = [],
    nombrePieceMin,
    nombrePieceMax,
    prixMin,
    prixMax,
  } = filters;

  return (
    (transaction.length === 0 || transaction.includes(annonce.transaction)) &&
    (type.length === 0 || type.includes(annonce.typeBien)) &&
    (exterieur.length === 0 || exterieur.includes(annonce.exterieur)) &&
    (!nombrePieceMin || annonce.nombrePiece >= nombrePieceMin) &&
    (!nombrePieceMax || annonce.nombrePiece <= nombrePieceMax) &&
    (!prixMin || annonce.prix >= prixMin) &&
    (!prixMax || annonce.prix <= prixMax)
  );
};
